// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"form-tab_tabHeader_7wsaF","tabHeaderTitle":"form-tab_tabHeaderTitle_1wkWa","title":"form-tab_title_1biV1","active":"form-tab_active_2Rbom"};